import { MagnifyingGlass } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import useQuickMenu from '../../QuickMenu/useQuickMenu';
import { FakeSearchBar, Placeholder, Shortcut } from './wrapper';

const GlobalSearch = () => {
  const { t } = useTranslation(['header']);
  const { openQuickMenu } = useQuickMenu();

  const userAgent = window.navigator.userAgent;
  let searchShortcut = (
    <Shortcut>
      (<kbd>Ctrl</kbd>+<kbd>K</kbd>)
    </Shortcut>
  );

  if (userAgent.indexOf('Mac') !== -1) {
    searchShortcut = (
      <Shortcut>
        (<kbd>⌘</kbd>+<kbd>K</kbd>)
      </Shortcut>
    );
  }

  return (
    <FakeSearchBar onClick={openQuickMenu} title={t('mainSearch.title', { ns: 'header' })}>
      <MagnifyingGlass size={16} weight="bold" />
      <Placeholder>
        {t('mainSearch.placeholder', { ns: 'header' })}
        {searchShortcut}
      </Placeholder>
    </FakeSearchBar>
  );
};

export default GlobalSearch;
